/**
 * แตะที่ว่างแล้วปิดคีย์บอร์ดระบบทุกหน้า — ให้เหมือนจอ native ที่ `FocusScope.unfocus()`
 *
 * ใช้ `pointerdown` บน document (capture) ไม่ใช่ `click` เพราะ iOS ยิง click
 * ช้ากว่า คีย์บอร์ดจะค้างอยู่ครู่หนึ่งก่อนยุบ
 *
 * ข้ามช่องกรอก/ปุ่ม/ลิงก์/label เพื่อไม่ตัดโฟกัสที่กำลังจะย้าย และไม่เลื่อน
 * เลย์เอาต์จนพลาด pointerup
 */
const KEEP_FOCUS =
  "input, textarea, select, button, a, label, summary, [contenteditable], [role='button']";

function onPointerDown(e: PointerEvent): void {
  const hit = e.target;
  if (hit instanceof Element && hit.closest(KEEP_FOCUS)) return;
  const active = document.activeElement;
  if (active instanceof HTMLElement && active !== document.body) active.blur();
}

export function dismissKeyboardOnFreeSpace(): () => void {
  if (typeof document === "undefined") return () => {};
  document.addEventListener("pointerdown", onPointerDown, true);
  return () => document.removeEventListener("pointerdown", onPointerDown, true);
}
